// extracted by mini-css-extract-plugin
export default {"container":"_3gsz0","button":"_2PWr5","actionsContainer":"_2I0OQ","center":"_11oWE","right":"_20kv3","triangle":"jZUi7","actionsPadding":"_36YhM"};